import { basePath, origin } from '@/config'

export default {
  methods: {
    computedURL(path) {
      if (process.env.VUE_ENV === 'server') {
        return `'${origin}${basePath}${path}'`
      }
      return `'${window.location.origin}${basePath}${path}'`
    }
  }
}



// WEBPACK FOOTER //
// ./src/util/computedURL.js